module.exports = __webpack_public_path__ + "img/pin_island_arrow.c76b7c6f.png";